import axiosInstance from "@/api/axios-instance";
import { Bundle } from "@/pages/bundles/types/bundle";

export interface BundleDetail extends Bundle {
  region_rel?: { id: string; code: string; display_name: string } | null;
  product?: { id: string; name: string } | null;
}

export async function getBundle(id: string): Promise<BundleDetail> {
  const r = await axiosInstance.get(`/bundle/${id}`);
  return r.data;
}
